import {combineReducers} from "redux";
import unitSettingViewModel from "./setting/unitSettingViewModel";
import unitSettingEditViewModel from "./setting/unitSettingEditViewModel";
import userSettingViewModel from "./usersetting/userSettingViewModel";
import logoSettingViewModel from "./logosetting/logoSettingViewModel";
import mobileBannerSettingViewModel from "./mobilebannersetting/mobileBannerSettingViewModel";
import accountPasswordLoginSettingViewModel from "./setting/accountPasswordLoginSettingViewModel";

const rootViewModel = combineReducers({
    unitSettingViewModel,
    unitSettingEditViewModel,
    userSettingViewModel,
    logoSettingViewModel,
    mobileBannerSettingViewModel,
    accountPasswordLoginSettingViewModel,
});

export default rootViewModel;
